var map = {
	"./BaseAnnouncementBanner": 28810,
	"./BaseAnnouncementBanner.vue": 28810,
	"./BaseButton": 18677,
	"./BaseButton.vue": 18677,
	"./BaseEmbeddedTip": 93192,
	"./BaseEmbeddedTip.vue": 93192,
	"./BaseFullScreenModal": 55319,
	"./BaseFullScreenModal.vue": 55319,
	"./BasePageTitle": 51283,
	"./BasePageTitle.vue": 51283,
	"./BaseSelectDropdown": 89327,
	"./BaseSelectDropdown.vue": 89327,
	"./BaseSpacerWithRuler": 75892,
	"./BaseSpacerWithRuler.vue": 75892,
	"./BaseSpinner": 13039,
	"./BaseSpinner.vue": 13039,
	"./BaseToggleSidebarButton": 98577,
	"./BaseToggleSidebarButton.vue": 98577,
	"./BaseUpsellButton": 51244,
	"./BaseUpsellButton.vue": 51244,
	"./form/BaseCheckbox": 86141,
	"./form/BaseCheckbox.vue": 86141,
	"./form/BaseInputField": 24503,
	"./form/BaseInputField.vue": 24503,
	"./form/BasePasswordInput": 72270,
	"./form/BasePasswordInput.vue": 72270,
	"./form/BaseSmallToggleSwitch": 42501,
	"./form/BaseSmallToggleSwitch.vue": 42501,
	"./form/BaseTagsInput": 85314,
	"./form/BaseTagsInput.vue": 85314,
	"./form/BaseTextArea": 58959,
	"./form/BaseTextArea.vue": 58959,
	"./icons/BaseArrowBoxIcon": 34135,
	"./icons/BaseArrowBoxIcon.vue": 34135,
	"./icons/BaseArrowDownIcon": 68770,
	"./icons/BaseArrowDownIcon.vue": 68770,
	"./icons/BaseArrowLongRight": 56823,
	"./icons/BaseArrowLongRight.vue": 56823,
	"./icons/BaseArrowRightIcon": 63538,
	"./icons/BaseArrowRightIcon.vue": 63538,
	"./icons/BaseArrowUpIcon": 78914,
	"./icons/BaseArrowUpIcon.vue": 78914,
	"./icons/BaseAtSymbolIcon": 80831,
	"./icons/BaseAtSymbolIcon.vue": 80831,
	"./icons/BaseBackIcon": 22645,
	"./icons/BaseBackIcon.vue": 22645,
	"./icons/BaseBannersIcon": 57591,
	"./icons/BaseBannersIcon.vue": 57591,
	"./icons/BaseBoltIcon": 69868,
	"./icons/BaseBoltIcon.vue": 69868,
	"./icons/BaseCheckCircleIcon": 21814,
	"./icons/BaseCheckCircleIcon.vue": 21814,
	"./icons/BaseChevronIcon": 43671,
	"./icons/BaseChevronIcon.vue": 43671,
	"./icons/BaseChevronRightIcon": 38995,
	"./icons/BaseChevronRightIcon.vue": 38995,
	"./icons/BaseClipboardIcon": 50699,
	"./icons/BaseClipboardIcon.vue": 50699,
	"./icons/BaseClockIcon": 46639,
	"./icons/BaseClockIcon.vue": 46639,
	"./icons/BaseCloseIcon": 46904,
	"./icons/BaseCloseIcon.vue": 46904,
	"./icons/BaseConversationIcon": 92106,
	"./icons/BaseConversationIcon.vue": 92106,
	"./icons/BaseCreditCardIcon": 85526,
	"./icons/BaseCreditCardIcon.vue": 85526,
	"./icons/BaseCsvFileIcon": 69288,
	"./icons/BaseCsvFileIcon.vue": 69288,
	"./icons/BaseCubeIcon": 45367,
	"./icons/BaseCubeIcon.vue": 45367,
	"./icons/BaseCurvedArrowIcon": 4715,
	"./icons/BaseCurvedArrowIcon.vue": 4715,
	"./icons/BaseCustomersIcon": 56865,
	"./icons/BaseCustomersIcon.vue": 56865,
	"./icons/BaseDeliverectIcon": 88771,
	"./icons/BaseDeliverectIcon.vue": 88771,
	"./icons/BaseDiscountIcon": 2544,
	"./icons/BaseDiscountIcon.vue": 2544,
	"./icons/BaseDocIcon": 27588,
	"./icons/BaseDocIcon.vue": 27588,
	"./icons/BaseDrinkIcon": 27651,
	"./icons/BaseDrinkIcon.vue": 27651,
	"./icons/BaseEditIcon": 78917,
	"./icons/BaseEditIcon.vue": 78917,
	"./icons/BaseEllipsisVerticalIcon": 78467,
	"./icons/BaseEllipsisVerticalIcon.vue": 78467,
	"./icons/BaseEmailIcon": 42701,
	"./icons/BaseEmailIcon.vue": 42701,
	"./icons/BaseExcelIcon": 95876,
	"./icons/BaseExcelIcon.vue": 95876,
	"./icons/BaseExitIcon": 15832,
	"./icons/BaseExitIcon.vue": 15832,
	"./icons/BaseExpandIcon": 9166,
	"./icons/BaseExpandIcon.vue": 9166,
	"./icons/BaseEyeHiddenIcon": 62380,
	"./icons/BaseEyeHiddenIcon.vue": 62380,
	"./icons/BaseEyeHiddenOutlineIcon": 47578,
	"./icons/BaseEyeHiddenOutlineIcon.vue": 47578,
	"./icons/BaseEyeIcon": 32367,
	"./icons/BaseEyeIcon.vue": 32367,
	"./icons/BaseEyeOutlineIcon": 32500,
	"./icons/BaseEyeOutlineIcon.vue": 32500,
	"./icons/BaseGreenTickIcon": 38749,
	"./icons/BaseGreenTickIcon.vue": 38749,
	"./icons/BaseHelpIcon": 41790,
	"./icons/BaseHelpIcon.vue": 41790,
	"./icons/BaseHomeIcon": 79453,
	"./icons/BaseHomeIcon.vue": 79453,
	"./icons/BaseImageUploadIcon": 7594,
	"./icons/BaseImageUploadIcon.vue": 7594,
	"./icons/BaseLightspeedIcon": 62422,
	"./icons/BaseLightspeedIcon.vue": 62422,
	"./icons/BaseLinkIcon": 67667,
	"./icons/BaseLinkIcon.vue": 67667,
	"./icons/BaseLockIcon": 67092,
	"./icons/BaseLockIcon.vue": 67092,
	"./icons/BaseMagicIcon": 19280,
	"./icons/BaseMagicIcon.vue": 19280,
	"./icons/BaseMapPinIcon": 27236,
	"./icons/BaseMapPinIcon.vue": 27236,
	"./icons/BaseMenuIcon": 94462,
	"./icons/BaseMenuIcon.vue": 94462,
	"./icons/BaseMenuItemIcon": 38992,
	"./icons/BaseMenuItemIcon.vue": 38992,
	"./icons/BaseMoonIcon": 95673,
	"./icons/BaseMoonIcon.vue": 95673,
	"./icons/BaseOrdersIcon": 70078,
	"./icons/BaseOrdersIcon.vue": 70078,
	"./icons/BasePaperClipIcon": 14644,
	"./icons/BasePaperClipIcon.vue": 14644,
	"./icons/BasePhoneIcon": 10219,
	"./icons/BasePhoneIcon.vue": 10219,
	"./icons/BasePictureIcon": 55162,
	"./icons/BasePictureIcon.vue": 55162,
	"./icons/BasePlusIcon": 6953,
	"./icons/BasePlusIcon.vue": 6953,
	"./icons/BasePrinterIcon": 98267,
	"./icons/BasePrinterIcon.vue": 98267,
	"./icons/BaseQrCodeIcon": 52319,
	"./icons/BaseQrCodeIcon.vue": 52319,
	"./icons/BaseQuestionIcon": 33006,
	"./icons/BaseQuestionIcon.vue": 33006,
	"./icons/BaseReceiptIcon": 75271,
	"./icons/BaseReceiptIcon.vue": 75271,
	"./icons/BaseRefreshIcon": 2662,
	"./icons/BaseRefreshIcon.vue": 2662,
	"./icons/BaseRefundIcon": 15355,
	"./icons/BaseRefundIcon.vue": 15355,
	"./icons/BaseReportIcon": 35441,
	"./icons/BaseReportIcon.vue": 35441,
	"./icons/BaseSearchIcon": 57821,
	"./icons/BaseSearchIcon.vue": 57821,
	"./icons/BaseSmallCloseIcon": 67539,
	"./icons/BaseSmallCloseIcon.vue": 67539,
	"./icons/BaseSmallSearchIcon": 97546,
	"./icons/BaseSmallSearchIcon.vue": 97546,
	"./icons/BaseSnoozeIcon": 89606,
	"./icons/BaseSnoozeIcon.vue": 89606,
	"./icons/BaseStackedCardsIcon": 82685,
	"./icons/BaseStackedCardsIcon.vue": 82685,
	"./icons/BaseStarIcon": 6258,
	"./icons/BaseStarIcon.vue": 6258,
	"./icons/BaseSunIcon": 79403,
	"./icons/BaseSunIcon.vue": 79403,
	"./icons/BaseTableIcon": 35235,
	"./icons/BaseTableIcon.vue": 35235,
	"./icons/BaseTextCenterIcon": 28956,
	"./icons/BaseTextCenterIcon.vue": 28956,
	"./icons/BaseTextJustifyIcon": 41964,
	"./icons/BaseTextJustifyIcon.vue": 41964,
	"./icons/BaseTextLeftIcon": 25309,
	"./icons/BaseTextLeftIcon.vue": 25309,
	"./icons/BaseTextRightIcon": 61934,
	"./icons/BaseTextRightIcon.vue": 61934,
	"./icons/BaseTickIcon": 65993,
	"./icons/BaseTickIcon.vue": 65993,
	"./icons/BaseTisslIcon": 69426,
	"./icons/BaseTisslIcon.vue": 69426,
	"./icons/BaseTrendingDownIcon": 64386,
	"./icons/BaseTrendingDownIcon.vue": 64386,
	"./icons/BaseTrendingUpIcon": 90024,
	"./icons/BaseTrendingUpIcon.vue": 90024,
	"./icons/BaseUnlockIcon": 6760,
	"./icons/BaseUnlockIcon.vue": 6760,
	"./icons/BaseWarningIcon": 63045,
	"./icons/BaseWarningIcon.vue": 63045,
	"./icons/BaseWhatsappIcon": 74671,
	"./icons/BaseWhatsappIcon.vue": 74671,
	"./icons/BaseZonalIcon": 50850,
	"./icons/BaseZonalIcon.vue": 50850,
	"./logos/BaseOpentableLogo": 28673,
	"./logos/BaseOpentableLogo.vue": 28673,
	"./logos/BaseZettleLogo": 84552,
	"./logos/BaseZettleLogo.vue": 84552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45807;